<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="col-4 left">
        {{ $t('sidebar.payslip') }} > {{ payslip.prlCode }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            v-if="showOptionButton"
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="options"
            @onSelect="handleSelectOption"
          />
          <!-- <BaseActionDropdown
            :icon="`fas fa-download`"
            :text="$t('button.download')"
            :items="[
              {
                icon: null,
                iconClassName: null,
                text: $t('message.filename', {string: 'PDF'}),
                textClassName: 'text-secondary',
                value: 'pdf',
              },
            ]"
            @onSelect="handleSelectDownload"
          />
          <BaseAction
            :icon="`fas fa-print`"
            :iconClassName="``"
            :text="$t('button.print')"
            :textClassName="``"
            @onClick="handleClickPrint"
          /> -->
          <BaseAction
            :icon="`fas fa-copy`"
            :iconClassName="``"
            :text="$t('button.clone')"
            :textClassName="``"
            @onClick="openCloneModal"
          />
          <BaseActionUpdateStatus
            v-if="hasRoleApprove"
            :docType="`prl`"
            :processStatus="payslip.process.status"
            :loading="loadingUpdateStatus"
            @onSelect="handleSelectStatus"
          />
          <!-- status message -->
          <div
            v-else
            class="dropdown nodro item">
            <BaseDocumentProcessStatus
              :docType="`prl`"
              :status="payslip.process.status"
            />
          </div>
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <WrapperDoc>
        <template #form>
          <PayrollPaySlipForm
            :state="payslip"
            :prlCode="payslip.prlCode"
            :groups="groups"
            :conditions="conditions"
            :employees="employees"
            :isSubmitted="isSubmitted"
            :edit="true"
            :disabled="disabledForm"
            :form.sync="form"
            :showActionButtons="!disabledForm"
            @onSubmit="handleSubmit"
          />
        </template>
        <template #ref>
          <DocRef
            :refDoc="`prl`"
            :refId="payslip.prlId"
            :refCode="payslip.prlCode"
            :showLog="getPayrollSetting.log_topic.is_active"
            :showAttachFile="getPayrollSetting.attach_file.is_active"
            :logTopics="getPayrollSetting.log_topic.options"
            :isSubmitted="isSubmitted"
          >
            <RefPRL
              :payslip="payslip"
              :disabled="!hasRoleCreate"
            />
          </DocRef>
        </template>
      </WrapperDoc>

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
      <BaseConfirmCloneModal
        :show="modalConfirmClone.show"
        :loading="modalConfirmClone.loading"
        @onClose="handleCloseCloneModal"
        @onCancel="handleCancleCloneModal"
        @onConfirm="handleConfirmCloneModal({
          payload: payloadClone,
          createApiFn: createPaySlip,
          redirectTo: 'PaySlipList',
          refCode: 'prl_code',
        })"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import { DOCUMENT_STATUS } from '@/helpers/enum'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'
import RefPRL from '@/components/apps/payroll/payslip/include/RefPRL.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'

export default {
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      loading: true,
      loadingUpdateStatus: false,
      isSubmitted: false,
      query: {
        id: this.$route.query.id,
        code: this.$route.query.code,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  components: {
    WrapperDoc,
    DocRef,
    RefPRL,
    BaseConfirmCloneModal,
  },

  computed: {
    ...mapState('payroll', {
      groups: 'employeeGroupList',
      conditions: 'conditionList',
      payslip: 'paySlipSingle',
    }),
    ...mapState('hrm', {
      employees: 'employeeList',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
      getPayrollSetting: 'getPayrollSetting',
    }),
    options () {
      const items = []
      const deleteItem = {
        icon: 'fas fa-trash',
        iconClassName: 'text-danger',
        text: this.$t('button.delete'),
        textClassName: 'text-danger',
        value: 'delete',
      }
      if (this.hasRoleDelete) {
        items.push(deleteItem)
      }
      return items
    },
    disabledForm () {
      return [
        'approved',
        'rejected',
      ].includes(this.payslip.status) || !this.hasRoleEdit
    },
    payloadClone() {
      return {
        'date_start': this.payslip.dateStart,
        'date_end': this.payslip.dateEnd,
        'note': this.payslip.note,
        'net': this.payslip.net,
        'employees': this.payslip.employees.map((emp) => {
          return {
            'emp_id': emp.empId,
            'emp_name': emp.name,
            'wage_amount': emp.wageAmount,
            'conditions': emp.conditions.map((cond) => {
              return {
                'condition_id': cond.conditionId,
                'name': cond.name,
                'amount': cond.amount,
                'is_increment': cond.isIncrement,
                'is_editable': cond.isEditable,
              }
            }),
          }
        }),
      }
    },
  },

  async created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 1,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 0, [{
      'name': this.query.code,
      'router': {
        'name': 'PaySlipList',
        'query': {
          id: this.query.id,
          name: this.query.code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 0,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('payroll', {
      getEmployeeGroupList: 'getEmployeeGroupList',
      getConditionList: 'getConditionList',
      getPaySlipSingle: 'getPaySlipSingle',
      updatePaySlip: 'updatePaySlip',
      updatePaySlipStatus: 'updatePaySlipStatus',
      deletePaySlip: 'deletePaySlip',
      createPaySlip: 'createPaySlip',
    }),
    ...mapActions('hrm', {
      getEmployeeList: 'getEmployeeList',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getEmployeeGroupList(params),
        this.getConditionList({
          ...params,
          'filter[deleted]': true,
        }),
        this.getEmployeeList(params),
        this.getPaySlipSingle(this.query.id),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getData (form = {}) {
      const employees = form.employees.map((emp) => {
        return {
          'emp_id': emp.empId,
          'emp_name': emp.name,
          'wage_amount': emp.wageAmount,
          'net': emp.net,
          'conditions': emp.conditions.map((cond) => {
            return {
              'condition_id': cond.conditionId,
              'name': cond.name,
              'amount': cond.amount,
              'is_increment': cond.isIncrement,
              'is_editable': cond.isEditable,
            }
          }),
        }
      })
      const net = employees.reduce((total, cur) => total + cur.net, 0)
      return {
        'date_start': toISODateString(form.dateStart),
        'date_end': toISODateString(form.dateEnd),
        'note': form.note,
        'net': net,
        'employees': employees,
      }
    },
    async handleSubmit (form = {}) {
      this.isSubmitted = true
      const data = this.getData(form)
      const responseUpdate = await this.updatePaySlip({ id: this.query.id, data })
      if (responseUpdate.success) {
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.payslip.prlCode }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    handleSelectDownload (value) {
      if (value === 'pdf') {
        // code here
      }
    },
    handleClickPrint () {
      // code here
    },
    async handleSelectStatus (status) {
      this.isSubmitted = true
      this.loadingUpdateStatus = true
      const response = await this.updatePaySlipStatus({ id: this.query.id, data: { status } })
      this.loadingUpdateStatus = false
      this.isSubmitted = false
      this.fetchData()
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deletePaySlip(this.query.id)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.payslip.prlCode }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'PaySlipList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/payslip/Edit.vue